import ApplicationSerializer from "./application";
import { EmbeddedRecordsMixin } from "@ember-data/serializer/rest";
import ENV from "glesys-controlpanel/config/environment";

export function listenerFrom(loadbalancer, frontend) {
  let backend = loadbalancer.backends.find((backend) => backend.name === frontend.backend);

  return {
    ...frontend,
    id: `${loadbalancer.loadbalancerid}_${frontend.name}`,
    mode: backend.mode,
    stickysessions: backend.stickysessions,
    connecttimeout: backend.connecttimeout,
    responsetimeout: backend.responsetimeout,
    targets: backend.targets.map((target) => ({
      ...target,
      id: `${loadbalancer.loadbalancerid}_${target.name}`,
    })),
  };
}

export default class LoadBalancerSerializer extends ApplicationSerializer.extend(EmbeddedRecordsMixin) {
  usesProxy = true;

  primaryKey = "loadbalancerid";

  attrs = {
    project: "projectkey",
    cost: { serialize: false },
    managedhosting: { serialize: false },
    ipv4: { serialize: false },
    ipv6: { serialize: false },
    listeners: {
      deserialize: "records",
      serialize: false,
    },
    ips: {
      key: "ipaddress",
      deserialize: "records",
      serialize: false,
    },
  };

  normalize(modelClass, resourceHash, prop) {
    resourceHash.ipaddress = resourceHash.ipaddress?.map(({ ipaddress }) => ({ ipaddress }));
    if (resourceHash.frontends) {
      resourceHash.listeners = resourceHash.frontends.map((frontend) => listenerFrom(resourceHash, frontend));
    }
    resourceHash.links = {
      loadBalancerErrors: `${ENV.apiBaseUri}/loadbalancer/errors?loadbalancerid=${resourceHash.loadbalancerid}`,
      certificates: `${ENV.apiBaseUri}/loadbalancer/listcertificate?loadbalancerid=${resourceHash.loadbalancerid}`,
    };

    return super.normalize(modelClass, resourceHash, prop);
  }
}
